import _ from 'lodash'
import { i18n } from '@/api/i18n'
// 克隆对象时，如果发现值以'i18n.' 开头，说明默认值需要翻译，否则 默认值''
export const cloneWithI18nOrBlank = (sourceObj, defaultValue) => {
  let target = _.cloneDeep(sourceObj)
  deepForOwn(target, defaultValue)

  return target
}

const deepForOwn = (obj, defaultValue) => {
  _.forOwn(obj, function (value, key) {
    if (_.isString(value)) {
      if (_.startsWith(value, 'i18n.')) {
        obj[key] = i18n.t(value.substring(5)) + ':'
        if (_.startsWith(value, 'i18n.returnEIR')) {
          obj[key] = i18n.t(value.substring(5))
        }
      } else {
        if (defaultValue !== undefined) {
          obj[key] = defaultValue
        }
      }
    } else if (_.isArray(value)) {
      _.forEach(value, function (row) {
        deepForOwn(row)
      })
    } else if (_.isObject(value)) {
      deepForOwn(obj[key])
    }
  })
}

// const i18nCustomizer = (value) => {
//   if (_.isString(value)) {
//     if (_.startsWith(value, 'i18n.')) {
//       return i18n.t(value)
//     } else {
//       return ''
//     }
//   } else {
//     return value
//     // 非字符串类型
//     // return value.cloneNode(true);
//   }
// }

export const value2label = (arr) => {
  const obj = {}
  arr.forEach(item => {
    obj[item.value] = item.label
  })
  return obj
}

export const label2value = (arr) => {
  const obj = {}
  arr.forEach(item => {
    obj[item.label] = item.value
  })
  return obj
}

export const getMapByLabelAndValue = {
  value2label,
  label2value
}

/**
 * 宽松解析「非标准 JSON」配置字符串，用于替代不安全的 eval('(' + str + ')')。
 * 支持以下非标准写法（系统配置 / 打印配置常见格式）：
 *   - 无引号 key：     {displayValue: true, height:60}
 *   - 单引号：         {font:'bold'}
 *   - 裸字符串值：     {fontOptions: bold}
 *   - 末尾多余逗号：   {a:1,}
 * 例：parseLooseJSON('{displayValue: true,height:60,width:0.5,fontSize:12}')
 *     => { displayValue:true, height:60, width:0.5, fontSize:12 }
 *
 * @param {String|Object} input    待解析的字符串（已是对象则原样返回）
 * @param {Object}        fallback 解析失败时的兜底返回值，默认 {}
 * @returns {Object}
 */
export const parseLooseJSON = (input, fallback = {}) => {
  if (input == null || input === '') return fallback
  if (typeof input === 'object') return input
  if (typeof input !== 'string') return fallback

  // 1) 先按标准 JSON 解析，命中直接返回
  try {
    return JSON.parse(input)
  } catch (e) { /* 非标准 JSON，走下面的宽松规范化 */ }

  // 2) 规范化成合法 JSON 后再解析
  try {
    const normalized = input
      .trim()
      .replace(/'/g, '"') // 单引号 -> 双引号
      .replace(/([{,]\s*)([A-Za-z_$][\w$]*)(\s*:)/g, '$1"$2"$3') // 无引号 key 加引号
      .replace(/:(\s*)([A-Za-z_$][\w$\-./ ]*?)(\s*[,}\]])/g, (m, sp, val, end) =>
        /^(true|false|null)$/.test(val) ? m : `:${sp}"${val.trim()}"${end}`) // 裸字符串值加引号（跳过 true/false/null）
      .replace(/,(\s*[}\]])/g, '$1') // 去掉末尾多余逗号
    return JSON.parse(normalized)
  } catch (e) {
    console.warn('[parseLooseJSON] 解析失败，返回兜底值:', input, e)
    return fallback
  }
}

